<template lang="pug">
  div(class="vkb-nak-n-number")
    label(v-if="label")
      span {{ label }}
      i.fo.fo-exclamation.info-tooltip.ml-1(v-if="tooltip")
        span(class="hint") {{ tooltip }}

    input(:value="localValue" :placeholder="placeholder" :readonly="readonly" type="text" @keydown="(e) => validateNumber(e)" @input="onInput")
    label(v-if="suffix") {{ suffix }}

    template(v-if="checkValid && !valid && error")
      div(v-if="theme == 'vkb'" class="hint-wrapper")
        div(class="hint error open")
          p {{ error }}

      div(v-else-if="theme == 'fsoel'" class="vkb-nak-hint")
        div(class="hint-error")
          p {{ error }}
</template>

<script>
import { formatMoney } from '@/modules/utils';

export default {
  name: 'nNumber',
  props: {
    checkValid: {
      type: Boolean,
      default: false
    },
    className: {
      type: String,
      default: ''
    },
    emptyValue: {
      type: [String, Number],
      default: ''
    },
    error: {
      type: String,
      default: ''
    },
    label: {
      type: String,
      default: ''
    },
    mandatory: {
      type: Boolean,
      default: false
    },
    max: {
      type: Number
    },
    min: {
      type: Number,
      default: 0,
    },
    placeholder: {
      type: String,
      default: ''
    },
    readonly: {
      type: Boolean,
      default: false
    },
    theme: {
      type: String,
      default: 'vkb'
    },
    tooltip: {
      type: String,
      default: ''
    },
    valid: {
      type: Boolean,
      default: true
    },
    value: {
      type: [ String, Number ],
      default: ''
    },
    format: {
      type: String,
      default: 'money'
    },
    suffix: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      localValue: '',
      validKeyCodes: [8, 9, 37, 38, 39, 40, 46]
    };
  },
  created() {
    this.localValue = this.value;
  },
  methods: {
    onInput(e) {
      let _value = e.target.value;
      _value = _value.toString().replace('.', '');
      _value = parseInt(_value, 10);
      if (!isNaN(_value)) {
        if (this.format == 'money') {
          this.localValue = formatMoney(_value);
        } else {
          this.localValue = _value;
        }
      } else {
        this.localValue = _value = ''; //this.emptyValue;
      }
      this.$emit('input', _value);
    },
    validateNumber(evt) {
      if (this.validKeyCodes.includes(evt.keyCode)) {
				return true ;
			}
			if (evt.keyCode == 32 || isNaN(evt.key)) {
				evt.preventDefault();
			}
		}
  },
  watch: {
    value: {
      handler(value) {
        if (this.format == 'money' && !!value) {
          this.localValue = formatMoney(value);
          return;
        }
        this.localValue = value;
      }
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/common/n-number.vue